function openTab(evt, index, prefix) {
  const verticalTabNavigation = document.getElementById(
    `${prefix}vertical-tabnavigation`,
  );
  console.log(verticalTabNavigation);
  console.log(`tabcontent-${prefix}${index}`);
  if (!evt.currentTarget.className.includes("active")) {
    document
      .getElementById(`tabcontent-${prefix}${index}`)
      .classList.add("active");
    evt.currentTarget.classList.add("active");
    return;
  }

  document
    .getElementById(`tabcontent-${prefix}${index}`)
    .classList.remove("active");
  evt.currentTarget.classList.remove("active");
}

function clickToReveal(evt) {
  const verticalTabNavigation = document.getElementById(
    `vertical-tabnavigation`,
  );
  const clickToOpen = verticalTabNavigation.querySelector(`.click-to-open`);
  clickToOpen.classList.add("active");
}
